var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Fieldset = function (_a) {
    var id = _a.id, legende = _a.legende, children = _a.children, legendeEnGras = _a.legendeEnGras, disabled = _a.disabled, texteAide = _a.texteAide, displayRequired = _a.displayRequired, classFieldset = _a.classFieldset, alignementHorizontal = _a.alignementHorizontal, error = _a.error, warning = _a.warning, valid = _a.valid;
    var fieldsetClassName = "fr-fieldset dsmi-fieldset";
    if (classFieldset) {
        fieldsetClassName = fieldsetClassName.concat(" ", classFieldset);
    }
    if (alignementHorizontal) {
        fieldsetClassName += " fr-fieldset--inline";
    }
    var fieldsetAttributs = {};
    var legendAttributs = {};
    var texteValidation = null;
    if (error) {
        fieldsetClassName += " fr-fieldset--error";
        fieldsetAttributs["role"] = "group";
        fieldsetAttributs["aria-labelledby"] = "".concat(id, "-legend");
        legendAttributs["id"] = "".concat(id, "-legend ");
        if (typeof error === 'object' && "message" in error && error.message) {
            fieldsetAttributs["aria-labelledby"] = "".concat(id, "-legend ").concat(id, "-desc");
            texteValidation = {
                id: "".concat(id, "-desc-valid"),
                message: error.message,
                className: "fr-error-text",
            };
        }
    }
    else if (warning) {
        fieldsetClassName += " fr-fieldset--warning";
        if (typeof warning === 'object' && "message" in warning && warning.message) {
            fieldsetAttributs["aria-labelledby"] = "".concat(id, "-legend ").concat(id, "-desc");
            texteValidation = {
                id: "".concat(id, "-desc-warning"),
                message: warning.message,
                className: "fr-warning-text",
            };
        }
    }
    else if (valid) {
        fieldsetClassName += " fr-fieldset--valid";
        if (typeof valid === 'object' && "message" in valid && valid.message) {
            fieldsetAttributs["aria-labelledby"] = "".concat(id, "-legend ").concat(id, "-desc");
            texteValidation = {
                id: "".concat(id, "-desc-valid"),
                message: valid.message,
                className: "fr-valid-text",
            };
        }
    }
    if (displayRequired) {
        fieldsetClassName += " required";
    }
    var legendeClassName = "fr-fieldset__legend";
    if (!legendeEnGras) {
        legendeClassName += " fr-text--regular";
    }
    return (React.createElement("div", { className: "fr-form-group" },
        React.createElement("fieldset", __assign({ className: fieldsetClassName, disabled: disabled }, fieldsetAttributs),
            React.createElement("legend", __assign({ className: legendeClassName }, legendAttributs),
                React.createElement("span", { className: "fr-legend-texte" }, legende),
                texteAide && React.createElement("span", { className: "fr-hint-text" }, texteAide)),
            React.createElement("div", { className: "fr-fieldset__content" }, children),
            texteValidation && (React.createElement("p", { id: texteValidation.id, className: texteValidation.className }, texteValidation.message)))));
};
export default Fieldset;
